import { object, string } from "yup";

const getReferencesInputs = (t) => [
  {
    name: "referenceName",
    label: t("references.fields.name.label"),
    type: "text",
    placeholder: t("references.fields.name.placeholder"),
  },
  {
    name: "referencePhone",
    label: t("references.fields.phone.label"),
    type: "text",
    placeholder: t("references.fields.phone.placeholder"),
  },
  {
    name: "referenceEmail",
    label: t("references.fields.email.label"),
    type: "email",
    placeholder: t("references.fields.email.placeholder"),
    prependIcon: "@",
  },
  {
    name: "referenceRelationship",
    label: t("references.fields.relationship.label"),
    type: "text",
    placeholder: t("references.fields.relationship.placeholder"),
  },
  {
    name: "referenceAddress1",
    label: t("references.fields.address1.label"),
    type: "text",
    placeholder: t("references.fields.address1.placeholder"),
  },
  {
    name: "referenceAddress2",
    label: t("common.addressLine2"),
    type: "text",
    placeholder: t("references.fields.address2.placeholder"),
  },
  {
    name: "referenceCity",
    label: t("references.fields.city.label"),
    type: "text",
    placeholder: t("references.fields.city.placeholder"),
  },
  {
    name: "referenceState",
    label: t("references.fields.state.label"),
    type: "text",
    placeholder: t("references.fields.state.placeholder"),
  },
  {
    name: "referenceZip",
    label: t("references.fields.zip.label"),
    type: "text",
    placeholder: t("references.fields.zip.placeholder"),
  },
];

const getValidationSchema = (t) =>
  object().shape({
    referenceName: string()
      .required(t("references.validation.nameRequired"))
      .min(2, t("references.validation.nameMin"))
      .max(100, t("references.validation.nameMax")),
    referencePhone: string().required(t("references.validation.phoneRequired")),
    referenceRelationship: string().required(
      t("references.validation.relationshipRequired")
    ),
    referenceType: string().required(t("references.validation.typeRequired")),
    referenceState: string()
      .max(2, t("references.validation.stateMax"))
      .matches(
        /^([A-Za-zÀ-ÖØ-öø-ÿ\s]*)$/gi,
        t("references.validation.stateLetters")
      ),
  });

export { getReferencesInputs, getValidationSchema };
